import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

// Agenda: filas tipo tabla con horario en columna fija.
export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="fe-seccion" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="fe-titulo-itinerario" />
        <Reveal>
          <ul className="fe-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="fe-itinerario-item" key={i} data-testid={`fe-itinerario-item-${i}`}>
                  <span className="fe-itinerario-hora">{item.hora}</span>
                  <div className="fe-itinerario-cuerpo">
                    <h3 className="fe-itinerario-titulo">
                      <Icono size={15} strokeWidth={1.8} />
                      {item.titulo}
                    </h3>
                    {item.descripcion && <p className="fe-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
